import React from 'react';
import { SAHeader } from '../../../components/singleComponents/headers/SuperAdminHeader/SAHeader';
import { TabClient } from '../../../components/singleComponents/tabs/TabClient';
import { AdminManagement } from './AdminManagement';
import { DashboardSuperAdmin } from './Dashboard/DashboardSuperAdmin';
import { FinanceSuperAdmin } from './Finance/FinanceSuperAdmin';

import { RootStyled } from './homeSA.styles';

export default function HomeSA() {
  const headings = [
    { title: 'Dashboard' },
    { title: 'Gerenciar administradores' },
    { title: 'Gerenciar finanças' },
  ];
  const panels = [
    { value: 0, component: <DashboardSuperAdmin /> },
    { value: 1, component: <AdminManagement /> },
    { value: 2, component: <FinanceSuperAdmin /> },
  ];

  return (
    <RootStyled>
      <SAHeader />
      <TabClient headings={headings} panels={panels} />
    </RootStyled>
  );
}
